import React, { useContext, useEffect, useState } from "react";
import MainCenterBox from "../MainCenterBox";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { SignInService } from "../../redux/features/AuthService";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Button from "../Common/Button";
import Cookies from "js-cookie";
import Loader from "../Common/Loader";
import { AuthContext } from "../../contexts/AuthContexts";

const SignIn = () => { // NOSONAR
  const { id } = useParams();
  document.title = "National Trust Registry | Sign In";
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [step, setStep] = useState(1);
  const [signInClicked, setSignInClicked] = useState(false);
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const validate = (values) => {
    const errors = {};
    if (step === 1) {
      if (!values.email) {
        errors.email = "*Email is required to login";
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
      ) {
        errors.email = "Invalid email address";
      }
    }

    if (step === 2) {
      if (!values.password) {
        errors.password = "*Please enter your password";
      }
    }

    return errors;
  };

  const { updateAuthStatus } = useContext(AuthContext);

  let initialValuesWithoutEmail = {
    email: Cookies.get("ntr-email-login") ? Cookies.get("ntr-email-login") : "",
    password: "",
    step: 1,
    timezone: "Asia/Kolkata",
    isEmail: "",
  };

  if (id) {
    initialValuesWithoutEmail.isEmail = id;
  }
  const formik = useFormik({
    initialValues: initialValuesWithoutEmail,
    validateOnChange: true,
    validateOnBlur: true,
    validate,
    onSubmit: async (values) => { // NOSONAR
      setSignInClicked(true);
      if (step === 1) {
        formik.validateForm().then((errors) => {
          if (Object.keys(errors).length === 0) {
            setStep(2);
          }
        });
      } else {
        setLoading(true);
        Cookies.set("ntr-email-login", values.email, { expires: 36400 });
        const response = await dispatch(SignInService(values));
        if (response.type === "auths/SignInService/fulfilled") {
          const payload = response?.payload;
          setErrorMessage(payload?.message, { autoClose: 3000 });
          Cookies.set("ntr-token", response?.payload?.data?.token);
          Cookies.set("ntr-email-login", values.email, { expires: 36400 });
          Cookies.set("ntr-verify-token", response?.payload?.data?.token);
          localStorage.setItem("profileInfo", JSON.stringify(payload?.data));
          if (response.payload.data.token == null) {
            Cookies.remove("ntr-token");
            Cookies.remove("ntr-verify-token");
            navigate("/sign-in");
          }
          if (payload?.status === 3) {
            navigate("/sign-up-verify");
          } else if (payload?.status === 1) {
            if (payload?.data?.role === 1) {
              Cookies.set("ntr-token", payload?.data?.token);
              updateAuthStatus(1);
              navigate("/");
            } else if (payload?.data?.profileStatus === 2) {
              if((payload?.data?.planExpiryDate && payload?.data?.graceDurationWillEndAt) || payload?.data?.parentId) {
                Cookies.set("ntr-token", payload?.data?.token);
                updateAuthStatus(1);
                navigate("/");
              } else {
                navigate("/subscription");
              }
            } else if (
              payload?.status === 1 &&
              payload?.data?.profileStatus === 3
            ) { // NOSONAR
              Cookies.set("ntr-token", payload?.data?.token);
              updateAuthStatus(1);
              navigate("/");
            }
          }
        } else {
          setSignInClicked(true);
          setErrorMessage(
            response?.payload?.response?.data?.message ||
              response?.payload?.response?.data?.error,
            {
              autoClose: 3000,
            }
          );
          const payload = response?.payload;
          if (payload?.response?.data?.status === 3) {
            navigate("/sign-in-verify");
          }
        }
        setLoading(false);
      }
    },
  });

  const handleNextButton = (e, steps) => {
    e.preventDefault();
    if (steps === 1) {
      formik.validateForm().then((errors) => {
        if (Object.keys(errors)[0] !== "email") {
          setStep(2);
        }
      });
    }
    if (steps === 2) {
      formik.validateForm().then((errors) => {
        if (Object.keys(errors).length === 0) {
          formik.submitForm();
        }
      });
    }
  };

  const handleBack = () => {
    navigate("/password-reset");
  };

  const handleStepBack = () => {
    formik.validateForm().then((errors) => {
      setStep(1);
    });
  };

  useEffect(() => {
    if (location.state?.passwordTab) {
      setStep(2);
    }
  }, [location.state?.passwordTab]);

  const handlePasswordChange = (e) => {
    if (signInClicked) {
      setSignInClicked(false);
    }
    formik.handleChange(e);
  };

  const handleEmailChange = (e) => { // NOSONAR
    if (signInClicked) {
      setSignInClicked(false);
    }
    formik.handleChange(e);
  };
  return (
    <>
      {loading && <Loader />}
      <MainCenterBox
        title="Sign In"
        className="col-xl-4 col-lg-6 col-md-8 m-auto"
      >
        {step === 1 && (
          <p className="text-center pb-4 mb-0">
            Welcome to The National Trust Registry. Enter your email to sign in.
          </p>
        )}
        {step === 2 ? (
          <div // NOSONAR
            className="mian_select_disabled_email col-8 cursor-pointer"
            onClick={() => handleStepBack()}
          >
            <div className="pe-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
              >
                <g clipPath="url(#clip0_1672_28162)">
                  <path
                    d="M15 3H3C2.175 3 1.5075 3.675 1.5075 4.5L1.5 13.5C1.5 14.325 2.175 15 3 15H15C15.825 15 16.5 14.325 16.5 13.5V4.5C16.5 3.675 15.825 3 15 3ZM14.7 6.1875L9.3975 9.5025C9.1575 9.6525 8.8425 9.6525 8.6025 9.5025L3.3 6.1875C3.1125 6.0675 3 5.865 3 5.6475C3 5.145 3.5475 4.845 3.975 5.1075L9 8.25L14.025 5.1075C14.4525 4.845 15 5.145 15 5.6475C15 5.865 14.8875 6.0675 14.7 6.1875Z"
                    fill="#42474E"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1672_28162">
                    <rect width="18" height="18" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>

            <div className="fw-medium signin_disabled_email w-100">
              {formik?.values?.email
                ? formik?.values?.email
                : Cookies.get("ntr-email-login")}
            </div>
            <div className="ps-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
              >
                <path d="M5.25 7.5L9 11.25L12.75 7.5H5.25Z" fill="#1A1C1E" />
              </svg>
            </div>
          </div>
        ) : (
          <></>
        )}

        <form onSubmit={formik.handleSubmit}>
          {step === 1 ? (
            <>
              <div className="main_form_box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clipPath="url(#clip0_1659_28499)">
                    <path
                      d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM19.6 8.25L12.53 12.67C12.21 12.87 11.79 12.87 11.47 12.67L4.4 8.25C4.15 8.09 4 7.82 4 7.53C4 6.86 4.73 6.46 5.3 6.81L12 11L18.7 6.81C19.27 6.46 20 6.86 20 7.53C20 7.82 19.85 8.09 19.6 8.25Z"
                      fill="#42474E"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1659_28499">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>

                <div className="form-group">
                  <input
                    type="text"
                    placeholder="Email"
                    onChange={handleEmailChange}
                    value={formik.values?.email}
                    name="email"
                    className="input-field"
                    onBlur={formik.handleBlur}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") handleNextButton(e, 1);
                    }}
                  />
                </div>
              </div>
              {formik.errors.email ? (
                <div className="error" dangerouslySetInnerHTML={{ __html: formik.errors.email }} />
              ) : null}
              {errorMessage && signInClicked && (
                <div className="error" dangerouslySetInnerHTML={{ __html: errorMessage }} />
              )}

              <div className="pt-4 btn-div w-100 d-flex justify-content-end align-items-center">
                <Button
                  type="submit"
                  onClick={(e) => {
                    handleNextButton(e, 1);
                  }}
                  className="btn-thm SiteBtn"
                  text="Continue"
                />
              </div>
            </>
          ) : (
            <>
              <div className="main_form_box d-flex align-items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="21"
                  viewBox="0 0 16 21"
                  fill="none"
                >
                  <path
                    d="M14 7H13V5C13 2.24 10.76 0 8 0C5.24 0 3 2.24 3 5V7H2C0.9 7 0 7.9 0 9V19C0 20.1 0.9 21 2 21H14C15.1 21 16 20.1 16 19V9C16 7.9 15.1 7 14 7ZM8 16C6.9 16 6 15.1 6 14C6 12.9 6.9 12 8 12C9.1 12 10 12.9 10 14C10 15.1 9.1 16 8 16ZM5 7V5C5 3.34 6.34 2 8 2C9.66 2 11 3.34 11 5V7H5Z"
                    fill="#42474E"
                  />
                </svg>
                <div className="form-group d-flex align-items-center">
                  <input
                    type={passwordVisible ? "text" : "password"}
                    className="input-field"
                    name="password"
                    id="password"
                    placeholder="Password"
                    onChange={handlePasswordChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.password}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") handleNextButton(e, 2);
                    }}
                  />
                  {passwordVisible ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      onClick={togglePasswordVisibility}
                    >
                      <path
                        d="M11.825 16.75C13.0083 16.75 14.0125 16.3375 14.8375 15.5125C15.6625 14.6875 16.075 13.6833 16.075 12.5C16.075 11.3167 15.6625 10.3125 14.8375 9.4875C14.0125 8.6625 13.0083 8.25 11.825 8.25C10.6417 8.25 9.6375 8.6625 8.8125 9.4875C7.9875 10.3125 7.575 11.3167 7.575 12.5C7.575 13.6833 7.9875 14.6875 8.8125 15.5125C9.6375 16.3375 10.6417 16.75 11.825 16.75ZM11.825 15.3C11.0417 15.3 10.3792 15.0292 9.8375 14.4875C9.29583 13.9458 9.025 13.2833 9.025 12.5C9.025 11.7167 9.29583 11.0542 9.8375 10.5125C10.3792 9.97083 11.0417 9.7 11.825 9.7C12.6083 9.7 13.2708 9.97083 13.8125 10.5125C14.3542 11.0542 14.625 11.7167 14.625 12.5C14.625 13.2833 14.3542 13.9458 13.8125 14.4875C13.2708 15.0292 12.6083 15.3 11.825 15.3ZM11.825 20C9.525 20 7.42917 19.375 5.5375 18.125C3.64583 16.875 2.18333 15.225 1.15 13.175C1.1 13.0917 1.0625 12.9917 1.0375 12.875C1.0125 12.7583 1 12.6333 1 12.5C1 12.3667 1.0125 12.2417 1.0375 12.125C1.0625 12.0083 1.1 11.9083 1.15 11.825C2.18333 9.775 3.64583 8.125 5.5375 6.875C7.42917 5.625 9.525 5 11.825 5C14.125 5 16.2208 5.625 18.1125 6.875C20.0042 8.125 21.4667 9.775 22.5 11.825C22.55 11.9083 22.5875 12.0083 22.6125 12.125C22.6375 12.2417 22.65 12.3667 22.65 12.5C22.65 12.6333 22.6375 12.7583 22.6125 12.875C22.5875 12.9917 22.55 13.0917 22.5 13.175C21.4667 15.225 20.0042 16.875 18.1125 18.125C16.2208 19.375 14.125 20 11.825 20Z"
                        fill="#44464E"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="17"
                      viewBox="0 0 22 17"
                      fill="none"
                      onClick={togglePasswordVisibility}
                    >
                      <path
                        d="M10.825 12.75C12.0083 12.75 13.0125 12.3375 13.8375 11.5125C14.6625 10.6875 15.075 9.68333 15.075 8.5C15.075 7.31667 14.6625 6.3125 13.8375 5.4875C13.0125 4.6625 12.0083 4.25 10.825 4.25C9.64167 4.25 8.6375 4.6625 7.8125 5.4875C6.9875 6.3125 6.575 7.31667 6.575 8.5C6.575 9.68333 6.9875 10.6875 7.8125 11.5125C8.6375 12.3375 9.64167 12.75 10.825 12.75ZM10.825 11.3C10.0417 11.3 9.37917 11.0292 8.8375 10.4875C8.29583 9.94583 8.025 9.28333 8.025 8.5C8.025 7.71667 8.29583 7.05417 8.8375 6.5125C9.37917 5.97083 10.0417 5.7 10.825 5.7C11.6083 5.7 12.2708 5.97083 12.8125 6.5125C13.3542 7.05417 13.625 7.71667 13.625 8.5C13.625 9.28333 13.3542 9.94583 12.8125 10.4875C12.2708 11.0292 11.6083 11.3 10.825 11.3ZM10.825 16C8.525 16 6.42917 15.375 4.5375 14.125C2.64583 12.875 1.18333 11.225 0.15 9.175C0.1 9.09167 0.0625 8.99167 0.0375 8.875C0.0125 8.75833 0 8.63333 0 8.5C0 8.36667 0.0125 8.24167 0.0375 8.125C0.0625 8.00833 0.1 7.90833 0.15 7.825C1.18333 5.775 2.64583 4.125 4.5375 2.875C6.42917 1.625 8.525 1 10.825 1C13.125 1 15.2208 1.625 17.1125 2.875C19.0042 4.125 20.4667 5.775 21.5 7.825C21.55 7.90833 21.5875 8.00833 21.6125 8.125C21.6375 8.24167 21.65 8.36667 21.65 8.5C21.65 8.63333 21.6375 8.75833 21.6125 8.875C21.5875 8.99167 21.55 9.09167 21.5 9.175C20.4667 11.225 19.0042 12.875 17.1125 14.125C15.2208 15.375 13.125 16 10.825 16Z"
                        fill="#44464E"
                      />
                      <path
                        d="M3 16L19 1"
                        stroke="#44464E"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                  )}
                </div>
              </div>
              {formik.errors.password ? (
                <div className="error" dangerouslySetInnerHTML={{ __html: formik.errors.password }} />
              ) : null}
              {errorMessage && signInClicked && (
                <div className="error" dangerouslySetInnerHTML={{ __html: errorMessage }} />
              )}
              <div className="mt-4 btn-div d-flex justify-content-between align-items-center">
                {step === 1 ? (
                  <div // NOSONAR
                    className="SiteBtn2"
                    onClick={() => navigate("/password-reset")}
                  >
                    Forgot Password
                  </div>
                ) : (
                  <div className="SiteBtn2" onClick={() => handleBack()}>
                    Forgot Password
                  </div>
                )}
                <Button
                  type="submit"
                  onClick={(e) => {
                    handleNextButton(e, 2);
                  }}
                  className="btn-thm SiteBtn"
                  text="Sign In"
                />
              </div>
            </>
          )}
        </form>
      </MainCenterBox>
    </>
  );
};

export default SignIn;
